import React from 'react';
import { useNavigate } from 'react-router-dom';

const CallToActionSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="md:py-20 md:px-container-margin">
      <div className="md:max-w-7xl md:mx-auto md:bg-primary-container md:rounded-3xl md:p-12 md:p-20 md:text-center md:relative md:overflow-hidden">
        <div className="md:relative md:z-10">
          <h2 className="md:font-display-lg md:text-display-lg md:text-white md:mb-6">Ready to start your next build?</h2>
          <p className="md:font-body-lg md:text-body-lg md:text-on-primary-container md:mb-10 md:max-w-2xl md:mx-auto">
            Join thousands of property owners who trust Buildon for their most critical construction and maintenance needs.
          </p>
          <div className="md:flex md:justify-center">
            <button
              onClick={() => navigate('/register')}
              className="md:bg-secondary md:text-on-secondary md:px-10 md:py-4 md:rounded-xl md:font-headline-sm md:text-headline-sm md:hover:brightness-110 md:active:scale-95 md:transition-all"
            >
              Get Started Now
            </button>
          </div>
        </div>
        {/* Abstract Pattern */}
        <div className="md:absolute md:inset-0 md:opacity-10 md:pointer-events-none">
          <svg fill="none" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg">
            <pattern height="40" id="grid" patternUnits="userSpaceOnUse" width="40">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" />
            </pattern>
            <rect fill="url(#grid)" height="100%" width="100%" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection;
